import { fetchWithCORSProxy } from '@elfsight/lib-utils';
import { clearUrl } from '@elfsight/widget-utils';
import { XMLParser } from 'fast-xml-parser';
import type { AudioItem, Source } from '../../../../types';

const ALWAYS_ARRAY = ['rss.channel.item'];

const options = {
  ignoreAttributes: false,
  parseAttributeValue: true,
  allowBooleanAttributes: true,
  attributeNamePrefix: '',
  isArray: (_: string, jpath: string) => ALWAYS_ARRAY.includes(jpath)
};

interface RssItem {
  enclosure: {
    url: string;
  };
  'itunes:duration': number | string;
  'itunes:image': {
    href: string;
  };
  'itunes:author': string;
  creator: string;
  title: string;
  pubDate: string;
  description: string;
}

const decodeHTMLEntities = (str: string) => {
  const textElement = new DOMParser().parseFromString(str, 'text/html');

  return textElement.documentElement.textContent ?? '';
};

export function rss(source: Source, widgetToken?: string) {
  if (typeof source !== 'string') {
    return;
  }

  return new Promise<(AudioItem | null)[]>((resolve, reject) => {
    parseFeed(source, widgetToken)
      .then((data) => {
        const parser = new XMLParser(options);
        const feed = parser.parse(data);

        const result = feed?.rss?.channel.item.map((item: RssItem) => {
          if (item.enclosure) {
            const {
              enclosure: { url: link },
              'itunes:duration': duration,
              'itunes:image': { href: image } = {},
              'itunes:author': itunesAuthor,
              creator: author,
              title,
              pubDate,
              description
            } = item;

            return {
              link,
              image,
              duration,
              description,
              title: decodeHTMLEntities(title) || clearUrl(link) || '',
              author: author || itunesAuthor || '',
              date: decodeHTMLEntities(pubDate)
            };
          }

          return false;
        });

        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const parseFeed = async (source: string, widgetToken?: string) => {
  const url = source;
  let fetchedData;
  try {
    fetchedData = await fetch(url)
      .then((response) => response.text())
      .then((data) => data);
  } catch {
    fetchedData = await fetchWithCORSProxy(url, widgetToken)
      .then((response) => response.text())
      .then((data) => data);
  }
  return fetchedData;
};
